/**
 * HomeRoute.jsx
 * Smart root-path component. Renders the public Banyan landing page for
 * unauthenticated visitors, and the full app (portfolio overview inside
 * MainLayout) for authenticated users. This preserves every existing
 * `navigate('/')` call elsewhere in the app.
 */

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import MainLayout from '../../layouts/MainLayout';
import PortfolioOverviewPage from '../portfolio/pages/PortfolioOverviewPage';
import LandingPage from './pages/LandingPage';

const HomeRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingAnimation />;
  }

  if (isAuthenticated) {
    return (
      <MainLayout>
        <PortfolioOverviewPage />
      </MainLayout>
    );
  }

  return <LandingPage />;
};

export default HomeRoute;
